var _circle, _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.25033,
    cy: 3.49999,
    r: 2.33333,
    stroke: "#34265c",
    strokeWidth: 0.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.25C9.7165 5.25 10.5 4.4665 10.5 3.5C10.5 2.5335 9.7165 1.75 8.75 1.75",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.25033,
    cy: 9.91668,
    rx: 4.08333,
    ry: 2.33333,
    stroke: "#34265c",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.16666C11.5233 8.39106 12.25 8.95937 12.25 9.62499C12.25 10.2254 11.6587 10.7467 10.7917 11.0077",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.b3c1477fd49153c9eae3a3f4c7b1d071.svg";
export { ForwardRef as ReactComponent };